import { BankOutlined } from "@ant-design/icons"
import { Select, type SelectProps } from "components/Select/Select"
import { Organization } from "interface/user"
import { memo, useMemo } from "react"
import { useAdminOrganizations } from "services/organizations"

export const SelectOrganization = memo(function SelectOrganization({
	hiddenOrganizations = [],
	value,
	...props
}: SelectProps<Organization["id"][]> & {
	hiddenOrganizations?: Organization["id"][]
}) {
	const { data = [], isFetching } = useAdminOrganizations()
	const options = useMemo(
		() =>
			data
				.filter(({ id }) => {
					const noOrgsToHide = !hiddenOrganizations.includes(id)
					const matchesValue = Array.isArray(value)
						? value.includes(id)
						: typeof value === "string" && id === value
					return noOrgsToHide || matchesValue
				})
				.map(({ id, name }) => ({
					value: id,
					label: name,
				})),
		[data, hiddenOrganizations, value],
	)

	return (
		<Select<Organization["id"][]>
			{...props}
			value={value}
			loading={isFetching}
			virtual={false}
			showSearch={{ optionFilterProp: "label" }}
			options={options}
			prefix={<BankOutlined aria-hidden />}
		/>
	)
}) as <T = Organization["id"]>(
	props: SelectProps<T> & { hiddenOrganizations?: Organization["id"][] },
) => React.ReactNode
